export class Breadcrumb{
    title: string;
    clickable: boolean;
    route?: string;
}

export function UseBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    return function (constructor: Function) {
        constructor.prototype.breadcrumbs = breadcrumbs;
    };
}
